<template>
  <div class="sueldos-layout">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'SueldosEmpresaLayout',
};
</script>

<style scoped>
.sueldos-layout {
  padding: 1rem;
}
</style>
